import { useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Header } from 'components/common/header/Header';
import { Button } from 'components/common/button/Button';
import { ShareOptions, ShareResultPreview } from 'components/cost';
import { usePaymentList } from 'hooks/usePayment';
import { useMeetingDetail } from 'hooks/useMeeting';
import { paymentStore } from 'store/paymentStore';
import { meetingStore } from 'store/meetingStore';
import { calculateSettlement } from 'common/utils/settlementCalculator';
import './CostShare.css';

export const CostShare = () => {
    const navigate = useNavigate();
    const { meetingId } = useParams();
    const [copied, setCopied] = useState(false);
    const { data: paymentData } = usePaymentList();
    const { data: meetingData } = useMeetingDetail();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (meetingId) {
            paymentStore.onGetPaymentList(meetingId);
            meetingStore.onGetMeetingDetail(meetingId);
        }
    }, [meetingId]);

    const payments = paymentData?.data || [];
    const meeting = meetingData?.data;

    const settlement = useMemo(() => {
        return calculateSettlement(payments);
    }, [payments]);

    const resultData = {
        meetingName: meeting?.title || '모임',
        totalAmount: settlement.totalAmount,
        participants: settlement.participantCount,
        perPerson: settlement.perPersonAmount,
        transactions: settlement.transactions
    };

    const shareText = `
[${resultData.meetingName} 정산 결과]

총 지출: ${resultData.totalAmount.toLocaleString('ko-KR')}원
1인당: ${resultData.perPerson.toLocaleString('ko-KR')}원

💸 정산 내역:
${resultData.transactions.map((t: any) =>
    `${t.from} → ${t.to}: ${t.amount.toLocaleString('ko-KR')}원`
).join('\n')}

📱 MO2 앱에서 확인하기
    `.trim();

    const handleCopyText = () => {
        navigator.clipboard.writeText(shareText);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleKakaoShare = () => {
        console.log('Kakao share');
    };

    const handleSMSShare = () => {
        console.log('SMS share');
    };

    const handleLinkShare = () => {
        const shareUrl = `${window.location.origin}/cost/${meetingId}`;
        navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleDone = () => {
        navigate(`/meeting/detail/${meetingId}`, { replace: true });
    };

    return (
        <div className="cost-share-wrapper">
            <Header title="정산 결과 공유" isSubPage />

            <div className="cost-share-content">
                <div className="share-success">
                    <div className="success-circle">
                        <div className="success-icon">✓</div>
                    </div>
                    <h2 className="success-title">정산이 완료되었어요!</h2>
                    <p className="success-description">
                        이제 결과를 참여자들과 공유해보세요
                    </p>
                </div>

                <ShareResultPreview
                    meetingName={resultData.meetingName}
                    totalAmount={resultData.totalAmount}
                    perPerson={resultData.perPerson}
                    transactions={resultData.transactions}
                />

                <ShareOptions
                    copied={copied}
                    onKakaoShare={handleKakaoShare}
                    onSMSShare={handleSMSShare}
                    onLinkShare={handleLinkShare}
                    onCopyText={handleCopyText}
                />

                <div className="share-preview">
                    <h3 className="preview-title-text">공유될 내용</h3>
                    <div className="preview-text-box">
                        <pre className="preview-text">{shareText}</pre>
                    </div>
                </div>

                <div className="share-notice">
                    <div className="notice-icon">💡</div>
                    <div className="notice-text">
                        참여자들에게 정산 내역이 전송됩니다
                    </div>
                </div>
            </div>

            <div className="cost-share-footer">
                <Button
                    text="완료"
                    onPress={handleDone}
                />
            </div>
        </div>
    );
};
